
// 自动生成的索引文件
// 这个目录下的文件不要手动修改，会被覆盖

export type Locale = 'ar' | 'de' | 'en' | 'es' | 'es_419' | 'fr' | 'it' | 'ja' | 'ko' | 'pt_BR' | 'pt_PT' | 'ru' | 'zh_CN';

export const localeMap: Record<Locale, string> = {
  'ar': 'العربية',
  'de': 'Deutsch',
  'en': 'English',
  'es': 'Español',
  'es_419': 'Español de América Latina',
  'fr': 'Français',
  'it': 'Italiano',
  'ja': '日本語',
  'ko': '한국어',
  'pt_BR': 'Português do Brasil',
  'pt_PT': 'Português Europeu',
  'ru': 'Русский',
  'zh_CN': '简体中文'
};

// 动态导入语言包
export const loadLocaleMessages = async (locale: Locale) => {
  switch (locale) {
    case 'ar': return import('./ar.json');
    case 'de': return import('./de.json');
    case 'en': return import('./en.json');
    case 'es': return import('./es.json');
    case 'es_419': return import('./es_419.json');
    case 'fr': return import('./fr.json');
    case 'it': return import('./it.json');
    case 'ja': return import('./ja.json');
    case 'ko': return import('./ko.json');
    case 'pt_BR': return import('./pt_BR.json');
    case 'pt_PT': return import('./pt_PT.json');
    case 'ru': return import('./ru.json');
    case 'zh_CN': return import('./zh_CN.json');
    default: throw new Error(`Locale '${locale}' not found`);
  }
};
